import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TTColumnManager from './TTColumnManager';
import { updateSourceColumn, updateTargetColumn } from 'redux/translationTable/TranslationTableActions';

const mapStateToProps = ({ targetFields, mappingFile, mapping }) => ({
  targetFields: targetFields.fields,
  sourceFields: mappingFile.mappingInfo.find(mapInfo => (mapInfo.container === mappingFile.divisions[mapping.activeDivision])).subGroups.map(subGroup => subGroup.columns.map(column => ({
    name: column,
    label: column
  }))).reduce((subGroupAcum, subgroups) => subGroupAcum.concat(subgroups))
});

const mapDispatchToProps = dispatch => ({
  ttActions: bindActionCreators({ updateSourceColumn, updateTargetColumn }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TTColumnManager);



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttColumnManager/TTColumnManagerConnector.js